import { useEffect } from "react";
import ReportWWVocEmissionTable from "./components/ReportWWVocEmissionTable";
import { profileStore } from "src/stores/profile-store";
import { useSearchParams } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

let isRequestCompany: string | null = null;
const WWTReportVocEmission = () => {
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("companyId");
  const profile = profileStore(useShallow((state) => state.profile));
  const requestProfile = profileStore(useShallow((state) => state.requestProfile));

  useEffect(() => {
    if (profile?.company && profile.company.length > 0 && companyId && (!isRequestCompany || isRequestCompany != companyId)) {
      const findSlot = profile.company.find((item) => item._id == companyId);
      if (findSlot) {
        requestProfile({ companyId: companyId });
        isRequestCompany = companyId;
      } else {
        window.location.pathname = "/unauthorized";
      }
    }
  }, [profile?.company]);

  return <ReportWWVocEmissionTable />;
};

export default WWTReportVocEmission;
// http://localhost:3000/vocs-inventory/waste-water-treatment/report-voc-emission?approveId=67034ace09369b76ad80498b&companyId=66a32c0aa3d1da9e2e5efeac
// http://localhost:3000/vocs-inventory/waste-water-treatment/report-voc-emission?approveId=6704ef967081603dffd79b3b&companyId=66a32c0aa3d1da9e2e5efeac
// https://chem-voc-dev-ajgjcfczf2fhc5g4.a01.azurefd.net/vocs-inventory/waste-water-treatment/report-voc-emission?approveId=67034ace09369b76ad80498b&companyId=66a32c0aa3d1da9e2e5efeac
